import Utilities from "../Utilities";

export class TableOnDraw {
    static sortableTable(settings, table, tApi) {
        $('tbody', table).attr({'sortable': true, 'data-sortable-handle': 'handle'});
        Utilities.initSortable(table);

        let data = {};
        $('tbody', table).on( "sortupdate", function( event, ui ) {
            $('tbody > tr', table).each((key, row) => {
                let rowData = tApi.row(row).data();
                data[rowData.id] = key+1
            });
            axios({
                method: 'PATCH',
                url: $(table).data('auto-save'),
                data: data
            }).then(response => {
                Forms.handleSuccess(response.data, null, ['runAuditContainer']);
            })
        });
    }
    static refillLevels(settings, table, tApi) {

    }
}
